import React, { useState, useContext } from "react";
// import { loginUser } from "../api/auth";
// import { AuthContext } from "../context/AuthContext";
import { useNavigate, Link, replace } from "react-router-dom";
import "../../styles/LoginandRegister/login.css";
import { saveData } from "../../utils/localstorage_constants";
import {
  IS_ADMIN,
  IS_LOGGED,
  USER_DATA,
} from "../../utils/localstorage_variables";
import { login_user } from "../../api/serverWrapper";
const Login = () => {
  let [phonenumber, setPhoneNumber] = useState(null);
  let [password, setPassword] = useState(null);
  //   const { login } = useContext(AuthContext);
  const navigate = useNavigate();

  const handlePhoneNumber = (e) => {
    phonenumber = e.target.value;
    setPhoneNumber(phonenumber);
  };

  const handlePassword = (e) => {
    password = e.target.value;
    setPassword(password);
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    console.log(phonenumber, password);

    const res = await login_user(phonenumber, password);
    console.log(res);

    if (res.success) {
      let userresp = res.data;
      saveData(IS_LOGGED, true);
      saveData(IS_ADMIN, userresp.IsAdmin ? true : false);
      saveData(USER_DATA, userresp);
      navigate("/", { replace: true });
    } else {
      alert(res.message || "Login failed");
    }
  };

  return (
    <div className="auth-container">
      <div className="auth-box">
        <h2>Login</h2>
        <form onSubmit={handleSubmit}>
          <input
            type="text"
            name="PhoneNumber"
            placeholder="Phone number"
            value={phonenumber}
            onChange={handlePhoneNumber}
            required
          />
          <input
            type="password"
            name="Password"
            placeholder="Password"
            value={password}
            onChange={handlePassword}
            required
          />
          <button type="submit">Login</button>
        </form>
        <p>
          Don’t have an account? <Link to="/register">Register</Link>
        </p>
      </div>
    </div>
  );
};

export default Login;
